import { useState } from 'react';
import { GroupPicker } from './GroupPicker.js';

interface CreateUserModalProps {
  allGroups: { name: string; description?: string }[];
  onCancel: () => void;
  onSubmit: (input: { email: string; name: string; groups: string[] }) => void;
  submitting: boolean;
  error: string | null;
}

export function CreateUserModal({
  allGroups,
  onCancel,
  onSubmit,
  submitting,
  error,
}: CreateUserModalProps) {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [selected, setSelected] = useState<string[]>([]);

  function toggle(group: string) {
    setSelected((s) => (s.includes(group) ? s.filter((g) => g !== group) : [...s, group]));
  }

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white border border-brand-200 max-w-2xl w-full mx-6 p-6 max-h-[90vh] overflow-y-auto">
        <h2 className="text-2xl font-display text-brand-800 mb-4">Add user</h2>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit({ email, name, groups: selected });
          }}
          className="space-y-4"
        >
          <label className="block">
            <span className="block text-sm font-medium text-brand-700 mb-1">Email</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              className="w-full border border-brand-200 px-3 py-2 outline-none focus:border-brand-500 bg-white"
            />
          </label>
          <label className="block">
            <span className="block text-sm font-medium text-brand-700 mb-1">Name</span>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="w-full border border-brand-200 px-3 py-2 outline-none focus:border-brand-500 bg-white"
            />
          </label>
          <div>
            <span className="block text-sm font-medium text-brand-700 mb-2">
              Initial groups
            </span>
            <GroupPicker allGroups={allGroups} selected={selected} onToggle={toggle} disabled={submitting} />
          </div>
          {error && <div className="text-sm text-red-700">{error}</div>}
          <div className="flex gap-2 justify-end">
            <button
              type="button"
              onClick={onCancel}
              disabled={submitting}
              className="px-4 py-2 text-brand-700 hover:bg-brand-100"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="bg-brand-600 hover:bg-brand-700 disabled:opacity-50 text-white px-4 py-2 font-display font-medium"
            >
              {submitting ? 'Creating…' : 'Create + send invite'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
